import { EventBus } from '@/event-bus.js';
import ContactService, {
  getContactByPhone,
  getContactBySchedule,
} from '@/services/contact-service';
import { selectContactByLatestInteraction } from '@/shared/utils/contact-helpers';
import { getTagsByProtocol } from '@/services/tag-service';
import {
  ADD_NEW_JOB,
  ADD_MESSAGE_STATUS,
  ADD_ATTENDANCE_JOB,
} from '@/store/mutation-types';
import i18n from '@/i18n';

import {
  activeJobVoice,
  getCampaignById,
  getQueueById,
  getScriptCampaign,
  getScriptQueue,
  qualifyJob,
  transfer,
  transferRequest,
  voiceRedial,
  transferAssistedAccept,
} from '@/services/voice-service';
import { getActiveJobsFromChannel } from '@/shared/utils/job-helpers';
import { getGroups } from '@/services/attendance-groups-service';

const actions = {
  async newVoice({ commit, dispatch, rootGetters }, newJob) {
    try {
      let contact = null;

      const agentId = rootGetters['attendance/attendance'].agentId;

      if (newJob.contactId) {
        console.log('search contact contactId');
        contact = await ContactService.getById(newJob.contactId);
      } else {
        if (newJob.schedule) {
          console.log('search contact schedule');
          const isTelemessage = !newJob.activeAttendance;
          contact = await getContactBySchedule(newJob.schedule, isTelemessage);
        } else {
          if (newJob.contactExternalIdentifier) {
            console.log('search contact contactExternalIdentifier');
            contact = await ContactService.getByIdentifier(
              newJob.contactExternalIdentifier,
              'contact_identifier',
              agentId,
              true,
            );
          } else {
            console.log('search contact phone');
            contact = await getContactByPhone(newJob.phone, agentId);
          }
        }
      }

      const groups = await getGroups(agentId);
      const attendanceGroupInfo = groups.find(
        (group) => group.id == newJob.attendanceGroupId,
      );
      const observationRequired = attendanceGroupInfo
        ? attendanceGroupInfo.observation_required
        : false;
      newJob.attendanceGroupInfo = { observationRequired };

      console.log('contact', contact);

      const tags = await getTagsByProtocol(newJob.protocol);
      if (newJob.activeAttendance) {
        const campaignId = newJob.voiceCampaign;
        newJob.campaign = await getCampaignById(campaignId);
        newJob.script = await getScriptCampaign(campaignId);
      } else {
        const queueId = newJob.voiceQueue;
        console.log('queueId', queueId);
        if (queueId) {
          newJob.queue = await getQueueById(queueId);
          newJob.script = await getScriptQueue(queueId);
        } else {
          newJob.queue = null;
          newJob.script = null;
        }
      }

      let contactSelected = null;
      if (contact.hasOwnProperty('data')) {
        if (contact.data.length > 1) {
          contactSelected = await selectContactByLatestInteraction(
            contact.data,
            newJob.phone,
            'voice',
          );
        } else {
          contactSelected = contact.data[0];
        }
      } else {
        contactSelected = contact;
      }

      newJob.contact = await dispatch('defaultContact', {
        contacts: contactSelected,
        protocol: newJob.protocol,
      });
      console.log('newJob.contact', newJob.contact);
      newJob.tags = tags;

      commit(ADD_NEW_JOB, newJob);

      dispatch('navigation', newJob);

      if (!newJob.closedWithoutQualify) {
        dispatch('channel/updateStatusVoice', 'in_attendance', { root: true });
      }

      if (newJob.callType != 'MANUAL') {
        dispatch(
          'showSnackbar',
          { text: 'newVoiceJob', type: 'success', browserNotify: true },
          { root: true },
        );
        console.log('ADD_MESSAGE_STATUS', ADD_MESSAGE_STATUS, commit);
        commit(`voice/${ADD_MESSAGE_STATUS}`, 'isService', { root: true });
      }
      window.console.groupEnd();

      if (!Array.isArray(contact)) dispatch('lastContactVoiceJob', newJob);
    } catch (err) {
      window.console.log(err);
    }
  },

  async addNewVoice({ commit, dispatch, rootGetters }, newJob) {
    try {
      let contact = null;

      const agentId = rootGetters['attendance/attendance'].agentId;

      if (newJob.contactId) {
        console.log('search contact contactId');
        contact = await ContactService.getById(newJob.contactId);
      } else {
        if (newJob.schedule) {
          console.log('search contact schedule');
          const isTelemessage = !newJob.activeAttendance;
          contact = await getContactBySchedule(newJob.schedule, isTelemessage);
        } else {
          if (newJob.contactExternalIdentifier) {
            console.log('search contact contactExternalIdentifier');
            contact = await ContactService.getByIdentifier(
              newJob.contactExternalIdentifier,
              'contact_identifier',
              agentId,
              true,
            );
          } else {
            console.log('search contact phone');
            contact = await getContactByPhone(newJob.phone, agentId);
          }
        }
      }

      const groups = await getGroups(agentId);
      const attendanceGroupInfo = groups.find(
        (group) => group.id == newJob.attendanceGroupId,
      );
      const observationRequired = attendanceGroupInfo
        ? attendanceGroupInfo.observation_required
        : false;
      newJob.attendanceGroupInfo = { observationRequired };

      const tags = await getTagsByProtocol(newJob.protocol);
      if (newJob.activeAttendance) {
        const campaignId = newJob.voiceCampaign;
        newJob.campaign = await getCampaignById(campaignId);
        newJob.script = await getScriptCampaign(campaignId);
      } else {
        const queueId = newJob.voiceQueue;
        if (queueId) {
          newJob.queue = await getQueueById(queueId);
          newJob.script = await getScriptQueue(queueId);
        } else {
          newJob.queue = null;
          newJob.script = null;
        }
      }

      let contactSelected = null;
      if (contact.hasOwnProperty('data')) {
        if (contact.data.length > 1) {
          contactSelected = await selectContactByLatestInteraction(
            contact.data,
            newJob.phone,
            'voice',
          );
        } else {
          contactSelected = contact.data[0];
        }
      } else {
        contactSelected = contact;
      }

      newJob.contact = await dispatch('defaultContact', {
        contacts: contactSelected,
        protocol: newJob.protocol,
      });
      newJob.tags = tags;

      const contacts = newJob?.contact;

      if (contacts && Array.isArray(contacts) && contacts.length === 0) {
        newJob.contact = {
          lastContact: null,
        };
      }

      // commit(ADD_NEW_JOB, newJob);
      await commit(ADD_ATTENDANCE_JOB, newJob);
      dispatch('navigation', newJob);

      // if (!newJob.closedWithoutQualify) {
      //   dispatch('channel/updateStatusVoice', 'in_attendance', { root: true });
      // }

      if (newJob.callType != 'MANUAL') {
        // dispatch('showSnackbar', { text: 'newVoiceJob', type: 'success', browserNotify: true }, { root: true })
        console.log('ADD_MESSAGE_STATUS', ADD_MESSAGE_STATUS, commit);
        commit(`voice/${ADD_MESSAGE_STATUS}`, 'isService', { root: true });
      }
      window.console.groupEnd();

      // if (!Array.isArray(contact)) dispatch('lastContactVoiceJob', newJob);
    } catch (err) {
      window.console.log(err);
    }
  },

  voiceTransfer({ dispatch }, job) {
    return new Promise((resolve, reject) => {
      transfer(job)
        .then((res) => {
          dispatch('removeActiveJob');
          dispatch('updateAgentStatusVoice');
          resolve(res);
        })
        .catch((err) => {
          const messageAlert = {
            text:
              err.response.data.reason == 'offline'
                ? 'voiceServerOffline'
                : `transferError.${err.response.data.cause}`,
          };
          dispatch('showSnackbar', messageAlert, { root: true });

          EventBus.$emit('closeDialogTransferCall');

          reject();
        });
    });
  },

  voiceTransferAssisted({ dispatch }, job) {
    return new Promise((resolve, reject) => {
      transfer(job)
        .then((res) => {
          dispatch('updateAgentStatusVoice');
          resolve(res);
        })
        .catch((err) => {
          const messageAlert = {
            text:
              err.response.data.reason == 'offline'
                ? 'voiceServerOffline'
                : `transferError.${err.response.data.cause}`,
          };
          dispatch('showSnackbar', messageAlert, { root: true });

          EventBus.$emit('closeDialogTransferCall');
          EventBus.$emit('enableButtonTransferAccepted');

          reject();
        });
    });
  },
  voiceTransferAssistedRequestAccepted({ dispatch }, job) {
    return new Promise((resolve, reject) => {
      transferRequest(job)
        .then((res) => {
          dispatch('removeActiveJob');
          dispatch('updateAgentStatusVoice');
          resolve(res);
        })
        .catch((err) => {
          const messageAlert = {
            text:
              err.response.data.reason == 'offline'
                ? 'voiceServerOffline'
                : `transferError.${err.response.data.cause}`,
          };
          dispatch('showSnackbar', messageAlert, { root: true });

          reject();
        });
    });
  },
  voiceTransferAssistedRequestCanceled({ dispatch }, job) {
    return new Promise((resolve, reject) => {
      transferRequest(job)
        .then((res) => {
          dispatch('updateAgentStatusVoice');
          resolve(res);
        })
        .catch((err) => {
          const messageAlert = {
            text:
              err.response.data.reason == 'offline'
                ? 'voiceServerOffline'
                : `transferError.${err.response.data.cause}`,
          };
          dispatch('showSnackbar', messageAlert, { root: true });

          reject();
        });
    });
  },

  updateAgentStatusVoice({ dispatch, rootState }) {
    const jobList = rootState.jobs.jobList;
    const statusChannelVoice = rootState.channel.channels.voice.status;
    const voiceJobs = getActiveJobsFromChannel('voice', jobList);
    const notVoiceJobs = voiceJobs.length == 0;
    const attendanceIsNotPaused =
      statusChannelVoice != 'paused' && statusChannelVoice != 'scheduled_pause';

    if (notVoiceJobs && attendanceIsNotPaused) {
      dispatch('channel/updateStatusVoice', 'available', { root: true });
    }
  },

  async activeJobVoice({ dispatch, rootState }, informations) {
    await activeJobVoice(informations).catch((err) => {
      const {
        response: { data },
      } = err;
      const groupName = rootState.attendanceGroups.groupList.find(
        (group) => group.queue_voice_context == data.queue_name,
      ).name;

      let errorMessage = 'triggerActiveJobError';
      if (data.reason == 'pause') {
        errorMessage = 'cannotActiveJobBecauseInPause';
      }
      if (data.reason && data.reason != '') {
        errorMessage = data.reason;
      }

      if (
        errorMessage == 'alreadyInAttendance' ||
        errorMessage == 'alreadyPreferential'
      ) {
        dispatch(
          'showSnackbar',
          {
            text: errorMessage,
            replaces: { agentId: data.agent_id, agentName: data.agent_name },
            history: true,
          },
          { root: true },
        );
        return;
      }

      if (errorMessage == 'clientOnHold') {
        dispatch(
          'showSnackbar',
          {
            text: data.reason,
            type: 'error',
            replaces: { agentId: groupName, agentName: data.queue_position },
            history: true,
          },
          { root: true },
        );
        return;
      }

      if (data.cause == 'blacklist') {
        dispatch(
          'showSnackbar',
          { text: 'contactInBlacklist', type: 'error', history: true },
          { root: true },
        );
        return;
      }

      if (errorMessage == 'agentCallOrgUnitBlocked') {
        dispatch(
          'showSnackbar',
          {
            text: i18n.t('callsBetweenAgentsNotAllowed'),
            type: 'error',
            history: true,
          },
          { root: true },
        );
        return;
      }

      if (errorMessage == 'agentVoiceDisconnected') {
        dispatch(
          'showSnackbar',
          {
            text: i18n.t('agentVoiceDisconnected'),
            type: 'error',
            history: true,
          },
          { root: true },
        );
        return;
      }

      dispatch(
        'showSnackbar',
        { text: errorMessage, type: 'error', history: true },
        { root: true },
      );
    });
  },

  voiceQualify({ dispatch }, informations) {
    return new Promise((resolve, reject) => {
      qualifyJob(informations)
        .then((response) => {
          dispatch(
            'showSnackbar',
            { text: 'qualificationSuccess', type: 'success' },
            { root: true },
          );
          console.log(response);
          resolve(response);
        })
        .catch((err) => {
          dispatch(
            'showSnackbar',
            {
              text: 'Não foi possível realizar a qualificação.',
              type: 'error',
            },
            { root: true },
          );
          reject(err);
        });
    });
  },

  lastContactVoiceJob({ dispatch }, job) {
    const param = { protocol: job.protocol, contactIdentifier: job.phone };

    dispatch('contact/lastContact', param, { root: true });
  },

  voiceRedial({ dispatch }, informations) {
    voiceRedial(informations).then((res) => {
      if (res.cause) {
        dispatch(
          'showSnackbar',
          { text: res.cause, type: 'error' },
          { root: true },
        );
        return;
      }

      dispatch('showSnackbar', { text: 'callAgainToContact' }, { root: true });
    });
  },
  voiceTransferAssistedAccept({ dispatch }, informations) {
    transferAssistedAccept(informations);
  },
};

export default actions;
